import React from "react";
import { Button, Icon } from "@amzn/awsui-components-react-v3";
import { TableHeader } from "./components";

export const DistributionsHeader = ({ ...props }) => {

    return (
        <>
            <TableHeader
                {...props}
                title="Workflows"
                actionButtons={
                    <div>
                        <Button onClick={props.refresh}>
                            <Icon name="refresh" />
                        </Button>
                    </div>
                }
            />
        </>
    );
};
